/*
*  Show weight
* @param {object} row
* @param {boolean} updateValue
* @param {number} weights
 */
import Autocomplete from "@mui/material/Autocomplete";
import {TextField} from "@mui/material";
import * as React from "react";

export default function RedeemVoucherShowWeightAddon ({row, updateValue, weights}) {

    if (row.a_type !== 'Dog') return null;
    return (
        <Autocomplete
            size={"medium"}
            value={row.a_weight}
            id="combo-weight"
            options={weights}
            sx={{width: 'calc(100% - 15px)', margin: 1}}
            renderInput={(params) =>
                <TextField {...params}
                           error={row.a_weight === '' || row.a_weight === null}
                           label={"Weight"}
                />
            }
            onChange={(e, v) => {
                updateValue(v, 'a_weight');
                return false;
            }}
        />
    )
}
